"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _constants = require("./constants");

var _ExitTile = _interopRequireDefault(require("./ExitTile.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var ExitIconContainer = _styledComponents.default.div.withConfig({
  displayName: "ExitTile__ExitIconContainer",
  componentId: "sc-32oxwi-0"
})(["display:inline-flex;align-items:center;justify-content:space-between;width:", ";color:", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return "calc(".concat(theme.space.large, " + ").concat(theme.space.normal, ")");
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.greyDark;
}, function (_ref3) {
  var left = _ref3.left;
  return left && "\n    flex-direction: row-reverse;\n\n    .exit-icon, .direction-icon {\n      transform: scaleX(-1);\n    }\n  ";
});

var ExitLabel = _styledComponents.default.span.withConfig({
  displayName: "ExitTile__ExitLabel",
  componentId: "sc-32oxwi-1"
})(["font-family:", ";font-size:", ";color:", ";padding:", ";border-radius:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontFamily.default;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSize.XSmall;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.greyDark;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.micro;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.borderRadius.normal;
});

var ExitTile = function ExitTile(_ref9) {
  var accessible = _ref9.accessible,
      theme = _ref9.theme,
      customProperties = _ref9.customProperties,
      isRightSide = _ref9.isRightSide,
      translation = _ref9.translation;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var language = _objectSpread(_objectSpread({}, _constants.TRANSLATION), translation);

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(ExitIconContainer, {
      accessible: accessible,
      left: !isRightSide,
      "aria-label": "Exit icon",
      customProperties: customProperties
    }, /*#__PURE__*/_react.default.createElement(ExitLabel, null, language.exit), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessible,
      icon: "DirectionRunIcon",
      fontsize: "medium",
      className: "exit-icon",
      color: "greyDark"
    }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessible,
      icon: "ArrowForward",
      fontsize: "medium",
      className: "direction-icon",
      color: "greyDark"
    }));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

ExitTile.propTypes = _ExitTile.default.PropTypes;
ExitTile.defaultProps = _ExitTile.default.DefaultProps;
var _default = ExitTile;
exports.default = _default;